import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { IsOptional } from 'class-validator'
import { BillingSettings } from './billing.model'
import {
	RestaurantContactSettings,
	RestaurantSettings,
	RestaurantSettingsRequest,
	RestaurantSettingsResponse,
} from './contact.model'
import { CustomerAppSettings } from './customer-app.model'
import { EmailTemplateSettings } from './email-template.model'
import { EmailSettings } from './email.model'
import { FeaturesSettings } from './features.model'
import { KitchenSettings } from './kitchen.model'
import { ReservationSettings } from './reservation.model'
import { ScheduleSettings } from './schedule.model'

export class SettingsResponse {
	@ApiProperty({ type: CustomerAppSettings })
	customerApp: CustomerAppSettings

	@ApiProperty({ type: ScheduleSettings })
	schedule?: ScheduleSettings

	@ApiProperty({ type: ReservationSettings })
	reservation: ReservationSettings

	@ApiProperty({ type: FeaturesSettings })
	features: FeaturesSettings

	@ApiProperty({ type: RestaurantSettingsResponse })
	restaurant: RestaurantSettingsResponse

	@ApiProperty({ type: KitchenSettings })
	kitchen: KitchenSettings

	@ApiPropertyOptional({ type: EmailTemplateSettings })
	emailTemplates?: EmailTemplateSettings

	@ApiProperty({ type: BillingSettings })
	billing: BillingSettings

	@ApiPropertyOptional({ type: EmailSettings })
	email: EmailSettings
}

export class SaveSettingsRequest {
	@ApiPropertyOptional({ type: CustomerAppSettings })
	@IsOptional()
	customerApp?: CustomerAppSettings

	@ApiPropertyOptional({ type: ScheduleSettings })
	@IsOptional()
	schedule?: ScheduleSettings

	@ApiPropertyOptional({ type: ReservationSettings })
	@IsOptional()
	reservation?: ReservationSettings

	@ApiPropertyOptional({ type: RestaurantSettingsRequest })
	@IsOptional()
	restaurant?: RestaurantSettingsRequest

	@ApiPropertyOptional({ type: KitchenSettings })
	@IsOptional()
	kitchen?: KitchenSettings

	@ApiPropertyOptional({ type: EmailTemplateSettings })
	@IsOptional()
	emailTemplates?: EmailTemplateSettings

	@ApiPropertyOptional({ type: BillingSettings })
	@IsOptional()
	billing?: BillingSettings

	@ApiPropertyOptional({ type: EmailSettings })
	@IsOptional()
	email: EmailSettings
}

export class WidgetSettingsResponse {
	@ApiProperty({ type: String })
	displayName: string

	@ApiPropertyOptional({ type: String })
	logoUrl?: string

	@ApiPropertyOptional({ type: String })
	bannerUrl?: string

	@ApiProperty({ type: Number })
	defaultReservationTime: number

	@ApiProperty({ type: ScheduleSettings })
	schedule?: ScheduleSettings

	@ApiProperty({ type: RestaurantSettings })
	restaurant: RestaurantContactSettings

	/** Canonical Google-Maps link built from the configured place id (fallback: address search). */
	@ApiPropertyOptional({ type: String })
	mapsUrl?: string
}
